import React from 'react';
import { useSelector } from 'react-redux';
import { ZoneShapeType } from '@src/core/features/zones/entites';
import { ZoneCircle, ZonePolygon } from './shapes';
import {
  selectDisplayNoFlyZones,
  selectDisplaySafeLandZones,
  useGetSafeLandZonesQuery,
  useGetZonesQuery,
} from '@src/core/features/zones/redux';
import { ArcSafeLand } from '@src/core/ui/arc-zafe-land';
import { ZonesControlProps } from './types';

const ZonesControl: React.FC<ZonesControlProps> = () => {
  const displayNoFlyZones = useSelector(selectDisplayNoFlyZones);
  const displaySafeLandZones = useSelector(selectDisplaySafeLandZones);
  const { data: zones = [], isLoading: zonesLoading } = useGetZonesQuery(undefined, {
    skip: !displayNoFlyZones,
  });
  const { data: safeLandZones = [] } = useGetSafeLandZonesQuery(undefined, {
    skip: !displaySafeLandZones,
  });

  return (
    <React.Fragment>
      {displayNoFlyZones && !zonesLoading && (
        <React.Fragment>
          {zones
            .filter((zone) => zone.isActive)
            .map((zone) => {
              if (zone.shape === ZoneShapeType.CIRCLE) {
                return <ZoneCircle key={zone.id} zone={zone} />;
              }
              if (zone.shape === ZoneShapeType.POLYGON) {
                return <ZonePolygon key={zone.id} zone={zone} />;
              }
              return null;
            })}
        </React.Fragment>
      )}
      {displaySafeLandZones &&
        safeLandZones
          .filter((z) => z.isActive)
          .map((z) => (
            <ArcSafeLand.default
              key={`safe-land-${z.id}`}
              position={{ lat: z.centerLatitude, lng: z.centerLongitude }}
            />
          ))}
    </React.Fragment>
  );
};

export default ZonesControl;